import { fetchWhoAmI, type CurrentUser } from '@/api/v4/auth.api';
import type { QueryClient } from '@tanstack/react-query';
import { currentUserQuery } from './use-current-user.query';
import { paths } from '@/routes/helpers/paths';
import { isInactiveAccountError } from '@/helpers/is-inactive-account-error';
import { isNoActiveSubscriptionError } from '@/helpers/is-no-active-subscription-error';
import { isUnauthorizedError } from '@/helpers/is-unauthorized-error';
import { clearUserData } from '@/helpers/logout-utils';

export const userLoader = (queryClient: QueryClient) => async () => {
  const query = currentUserQuery();
  try {
    const cashedUser = queryClient.getQueryData<CurrentUser>(query.queryKey);
    if (cashedUser) return cashedUser;

    const user = await fetchWhoAmI();
    queryClient.setQueryData(query.queryKey, user);
    return user;
  } catch (error) {
    if (isInactiveAccountError(error)) {
      clearUserData({ queryClient, useJotaiStore: true });

      setTimeout(() => {
        window.open(paths.signIn(), '_self');
      }, 0);
      return null;
    }

    if (isNoActiveSubscriptionError(error)) {
      window.open(paths.accountDisabled(), '_self');
      return null;
    }

    if (isUnauthorizedError(error)) {
      clearUserData({ queryClient, useJotaiStore: true });

      setTimeout(() => {
        window.open(paths.signIn(), '_self');
      }, 0);
      return null;
    }

    return null;
  }
};
